import { createAsyncThunk } from "@reduxjs/toolkit";
import i18next from "i18next";
import { toast } from "react-toastify";
import { apiCall } from "services/api";

import { RoleTypes, RolesFilters, UpdateRole } from "./types";

export const getAllRoles = createAsyncThunk(
  "/auth/roles",
  async (filters: RolesFilters, { rejectWithValue }) => {
    try {
      const response = await apiCall().get("/auth/roles", { params: filters });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateRole = createAsyncThunk(
  "/auth/roles/:name",
  async (
    payload: { roleName: string; updatedRole: UpdateRole },
    { rejectWithValue }
  ) => {
    try {
      const response = await apiCall().patch(
        `/auth/roles/${payload.roleName}`,
        payload.updatedRole
      );
      toast.success(
        i18next.getResource(
          i18next.language,
          "translation",
          "userRolesSettings.roleUpdated"
        )
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createRole = createAsyncThunk(
  "/auth/roles/create",
  async (
    payload: {
      role: {
        label: string;
        secrecy: number;
        permissions: string[];
        type: RoleTypes;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await apiCall().post("/auth/roles", {
        label: payload.role.label,
        secrecy: payload.role.secrecy,
        permissions: payload.role.permissions,
        type: payload.role.type,
      });
      toast.success(
        i18next.getResource(
          i18next.language,
          "translation",
          "userRolesSettings.newRoleAdded"
        )
      );
      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteRole = createAsyncThunk(
  "/auth/roles/delete",
  async (roleName: string, { rejectWithValue }) => {
    try {
      const response = await apiCall().delete(`/auth/roles/${roleName}`);
      toast.success(
        i18next.getResource(
          i18next.language,
          "translation",
          "userRolesSettings.roleDeleted"
        )
      );
      return { response: response.data, roleName: roleName };
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getMeetingRoles = createAsyncThunk(
  "/auth/roles/meeting",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall({}).get(
        "/enums/single?enum=Domain\\Meeting\\Enums\\MeetingRoles"
      );

      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
